// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'
import { Field } from 'redux-form'
import { CheckboxGroup } from 'components/Form'

const Toggle = ({ idRoot, onChangeCustom, options }) => (
  <Field
    checkBoxClasses={'advanced-search-toggle user-select-none'}
    component={CheckboxGroup}
    idRoot={`${idRoot}advanced-search`}
    name={'advancedSearch'}
    onChangeCustom={onChangeCustom}
    options={options} />
)

Toggle.propTypes = {
  idRoot: string.isRequired,
  onChangeCustom: func.isRequired,
  options: array.isRequired,
}

export default Toggle
